module.exports = __webpack_public_path__ + "img/shopIcon9.f7e87e61.png";